package pl.decks.personal.pages.blog

import pl.decks.personal.components.layouts.blog.BlogPostData


object BlogPostRegistry {
    private val _entries: MutableList<BlogPostEntry> = mutableListOf()

    @Suppress("unused")
    fun registerEntry(route: String, blogPostData: BlogPostData) {
        _entries += BlogPostEntry(route, blogPostData)
    }

    fun getEntries(): List<BlogPostEntry> = _entries.toList().sortedByDescending { it.blogPostData.date }
}
